import {soundManager} from 'soundmanager2';

// const sm2m = require('soundmanager2/script/soundmanager2');
window.sm2 = soundManager;
function loadJSON(path, success, error)
{
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function()
    {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            if (xhr.status === 200) {
                if (success)
                    success(JSON.parse(xhr.responseText));
            } else {
                if (error)
                    error(xhr);
            }
        }
    };
    xhr.open("GET", path, true);
    xhr.send();
}

function isJson(item) {
    item = typeof item !== "string"
        ? JSON.stringify(item)
        : item;

    try {
        item = JSON.parse(item);
    } catch (e) {
        return false;
    }

    if (typeof item === "object" && item !== null) {
        return true;
    }

    return false;
}


document.addEventListener('alpine:init', () => {
    window.Alpine.store('audioPlayer', {
        sm2: null,
        audio: null,
        track_id: null,
        playing: false,
        progress: null,
        lyrics: null,
        lyricsCurrent: null,

        init()
        {
            sm2 = soundManager;
            let that = this;
            sm2.setup({
                debugMode: false,
                // useFastPolling: true,
                useHighPerformance: true,
                onready: function() {
                    that.audio = soundManager.createSound({
                        id: 'audio',
                        url: '',
                        whileloading: function() {
                            let element_total = document.querySelector('.player__time-total[data-id="'+that.track_id+'"]');
                            if( element_total !== null ){
                                element_total.textContent = that.formatMilliseconds(that.audio.durationEstimate);
                            }
                        },
                        whileplaying: function() {
                            let element_elapsed = document.querySelector('.player__time-elapsed[data-id="'+that.track_id+'"]');
                            if( element_elapsed !== null ){
                                element_elapsed.textContent = that.formatMilliseconds(that.audio.position);
                            }

                            let element_progressBar = document.querySelector('.player__progressBar[data-id="'+that.track_id+'"]');
                            if( element_progressBar !== null ) {
                                that.progress = that.audio.position * 100 / that.audio.duration;
                                element_progressBar.style.width = that.progress + '%';
                            }

                            let element_total = document.querySelector('.player__time-total[data-id="'+that.track_id+'"]');
                            if( element_total !== null && element_total.textContent !== that.audio.duration ){
                                element_total.textContent = that.formatMilliseconds(that.audio.duration);
                            }

                            if( that.lyrics !== null && isJson(that.lyrics) )
                            {
                                let lyrics_container = document.querySelector('.player__lyrics[data-id="' + that.track_id + '"]');
                                let currentText = '&nbsp;';

                                for (var i = 0; i < that.lyrics.lyrics.length; i++) {
                                    if (parseFloat(that.lyrics.lyrics[i].start) <= that.audio.position && parseFloat(that.lyrics.lyrics[i].end) >= that.audio.position) {
                                        currentText = that.lyrics.lyrics[i].text;
                                    }

                                    if (that.lyricsCurrent !== currentText) {
                                        that.lyricsCurrent = currentText;
                                        lyrics_container.style.opacity = 0;
                                        lyrics_container.innerHTML = currentText;
                                        lyrics_container.style.opacity = 1;

                                        // setTimeout(function(){
                                        // }, 100);
                                        // lyrics_container.innerHTML = currentText;
                                        // lyrics_container.style.opacity = 1;
                                        // lyrics_container.className = lyrics_container.className + " show";
                                    }
                                }
                            }

                            let btnMainPlay    = document.querySelector('.player_main__play');
                            let btnMainPause   = document.querySelector('.player_main__pause');

                            if( btnMainPlay !== null ) {
                                btnMainPlay.style.display = "none";
                            }
                            if( btnMainPause !== null ) {
                                btnMainPause.style.display = "block";
                            }
                        },
                        onload: function() {
                            let element_total = document.querySelector('.player__time-total[data-id="'+that.track_id+'"]');
                            if( element_total !== null ){
                                element_total.textContent = that.formatMilliseconds(that.audio.duration);
                            }
                        },
                        onerror: function(code, description) {
                            window.Toast.fire({
                                title: 'مشکلی در پخش وجود دارد! لطفا کمی بعد دوباره امتحان کنید',
                                icon: 'error',
                            })
                            that.playerStop(true);
                        },
                        onfinish: function() {
                            that.playerStop(true);
                        }
                    });
                }
            });

        },

        toggle() {
            this.playing = ! this.playing
        },

        isPlaying(){
            return this.playing;
        },

        isPlayingItem(item_id) {
            if (this.audio === null) {
                return false;
            }
            if( !this.isSelectedItem(item_id) )
                return false;

            if (this.audio.playState === 0 || this.audio.paused === true) {
                return false;
            }

            return true;
        },

        isSelectedItem(item_id) {
            if (this.audio === null) {
                return false;
            }
            if (this.track_id !== item_id) {
                return false;
            }
            return true;
        },

        playItem(item_id, url){

            if (this.audio === null)
                return;

            let that = this;

            if( this.track_id !== item_id ){
                this.audio.stop();
                this.audio.url = url;
                this.track_id = item_id;
                loadJSON(HOME_URL + '/audio/' + item_id + '/lyrics.json',
                    function (data) {
                        that.lyrics = data;
                    },
                    function (xhr) {
                        console.error(xhr);
                    }
                );
            }

            this.playerStop(false);

            let elementPlay = document.querySelector('.player__play[data-id="'+item_id+'"]');
            let elementPause = document.querySelector('.player__pause[data-id="'+item_id+'"]');

            let btnMainPlay    = document.querySelector('.player_main__play');
            let btnMainPause   = document.querySelector('.player_main__pause');

            if (this.audio.playState === 0 || this.audio.paused === true) {
                this.audio.play();
                if( elementPlay !== null )
                    elementPlay.style.display = "none";

                if( elementPause !== null )
                    elementPause.style.display = "block";

                if( btnMainPlay !== null ) {
                    btnMainPlay.style.display = "none";
                }
                if( btnMainPause !== null ) {
                    btnMainPause.style.display = "block";
                }
            } else {
                this.audio.pause();
                if( elementPlay !== null )
                    elementPlay.style.display = "block";

                if( elementPause !== null )
                    elementPause.style.display = "none";

                if( btnMainPlay !== null ) {
                    btnMainPlay.style.display = "block";
                }
                if( btnMainPause !== null ) {
                    btnMainPause.style.display = "none";
                }
            }


            // this.audio = audio;
        },

        backward()
        {
            if (this.audio === null) {
                return;
            }

            var position = this.audio.position - 10000 < 0 ? 0 : this.audio.position - 10000;
            this.audio.setPosition(position);
            let element_elapsed = document.querySelector('.player__time-elapsed[data-id="'+this.track_id+'"]');
            if( element_elapsed !== null )
                element_elapsed.textContent = this.formatMilliseconds(this.audio.position);
        },

        forward()
        {
            if (this.audio === null) {
                return;
            }

            var position = this.audio.position + 10000 > this.audio.duration ? this.audio.duration : this.audio.position + 10000;
            if (position === this.audio.duration) {
                playerStop();
            } else {
                this.audio.setPosition(position);
                let element_elapsed = document.querySelector('.player__time-elapsed[data-id="'+this.track_id+'"]');
                if( element_elapsed !== null )
                    element_elapsed.textContent = this.formatMilliseconds(this.audio.position);
            }
        },

        onClickProgress (item_id, event) {
            if( item_id === this.track_id ) {
                let el = document.querySelector('.player__seekBar[data-id="' + item_id + '"]');
                if (el !== null) {
                    let mousePos = event.offsetX,
                        elWidth = el.clientWidth,
                        percents = (mousePos / elWidth) * 100;
                    this.audio.setPosition((percents * this.audio.duration) / 100);
                }
            }
        },

        playerStop(stop) {
            if (this.audio !== null && stop) {
                this.audio.stop();
            }
            let allPlays    = document.querySelectorAll('.player__play');
            let allPauses   = document.querySelectorAll('.player__pause');
            allPlays.forEach(function(element) {
                element.style.display = "block";
            });
            allPauses.forEach(function(element) {
                element.style.display = "none";
            });

            let btnMainPlay    = document.querySelector('.player_main__play');
            let btnMainPause   = document.querySelector('.player_main__pause');

            if( btnMainPlay !== null ){
                btnMainPlay.style.display = "block";
            }
            if( btnMainPause !== null ){
                btnMainPause.style.display = "none";
            }
        },

        formatMilliseconds(milliseconds) {
            var hours = Math.floor(milliseconds / 3600000);
            milliseconds = milliseconds % 3600000;
            var minutes = Math.floor(milliseconds / 60000);
            milliseconds = milliseconds % 60000;
            var seconds = Math.floor(milliseconds / 1000);
            milliseconds = Math.floor(milliseconds % 1000);

            return (minutes < 10 ? '0' : '') + minutes + ':' +  (seconds < 10 ? '0' : '') + seconds;
        },
    })
})
